import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ReactLoading from "react-loading";
import { formatDate } from "../../../../../../utils/commonFunctions";
import { Card, message } from "antd";
import swal from "sweetalert";
import {
  hasNumeric,
  hasSpecialCharacter,
  isNameValid,
  isValidAddress,
} from "./commonfunctions";
import useAxios from "../../../../../../hooks/useAxios";

function calculateAge(dateOfBirth) {
  const dob = new Date(dateOfBirth);
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const hasBirthdayPassedThisYear =
    today.getMonth() > dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

  if (!hasBirthdayPassedThisYear) {
    age--;
  }

  return age;
}

function Gratuity({
  form,
  filledForm,
  getAllJoiningFilledForms,
  aadharDetails,
  metaData,
  setGratuityPreviewData,
  setActivePanel,
  application,
  nomineeWages,
  nomineeEPF,
  setIsFieldTouch,
}) {
  let prefilledNominees = null;

  if (nomineeEPF && !prefilledNominees) {
    if (nomineeEPF?.documentDetails?.useNominee) {
      if (nomineeEPF?.documentDetails?.nominees?.length !== 0) {
        prefilledNominees = nomineeEPF?.documentDetails?.nominees?.map(
          (ele) => ({
            name_of_nominee: ele?.name_and_address_of_nominee,
            relationship: ele?.nominee_relationship,
            age_of_nominee: calculateAge(ele?.date_of_birth),
            total_amount: Number(ele?.total_amount),
          })
        );
      }
    }
  }
  if (nomineeWages && !prefilledNominees) {
    if (nomineeWages?.documentDetails?.useNominee) {
      if (nomineeWages?.documentDetails?.nominees?.length !== 0) {
        prefilledNominees = nomineeWages?.documentDetails?.nominees?.map(
          (ele) => ({
            name_of_nominee: `${ele?.name_of_nominee}, ${ele?.address}`,
            relationship: ele?.nominee_relationship,
            age_of_nominee: calculateAge(ele?.date_of_birth),
            total_amount: Number(ele?.total_amount),
          })
        );
      }
    }
  }

  let row = 0;
  const IS_DISABLE =
    filledForm?.formStatusByHR === false
      ? !application?.candidateSignatureStatus
        ? true
        : false
      : false;
  let _aadhar = aadharDetails || {};
  const { house, street, state, loc, dist } =
    _aadhar?.aadharVerificationDetails?.data?.address || {};
  const ADDRESS =
    _aadhar?.aadharVerificationDetails?.data?.full_address ||
    [house, street, state, loc, dist].filter(Boolean).join(", ") ||
    "";

  const AADHAR_GENDER = _aadhar?.aadharVerificationDetails?.data?.gender || "";

  const FORM_GENDER =
    application?.responses?.find((item) => item?.label === "Gender")?.value ||
    "";

  const GENDER = AADHAR_GENDER
    ? AADHAR_GENDER === "M"
      ? "male"
      : AADHAR_GENDER === "F"
      ? "female"
      : ""
    : FORM_GENDER
    ? FORM_GENDER?.toLowerCase()
    : "";
  const api = useAxios();
  const { id } = useParams();
  const [useNominee, setUseNominee] = useState(
    filledForm?.documentDetails?.useNominee ? true : false
  );
  const [nominees, setNominees] = useState(
    !filledForm?.documentDetails
      ? prefilledNominees
        ? [...prefilledNominees]
        : [
            {
              name_of_nominee: "",
              relationship: "",
              age_of_nominee: "",
              total_amount: "",
            },
          ]
      : [...filledForm?.documentDetails?.nominees]
  );

  const [formData, setFormData] = useState({
    name_of_employee:
      filledForm?.documentDetails?.name_of_employee ||
      _aadhar?.aadharVerificationDetails?.data?.full_name ||
      (metaData?.first_name || metaData?.last_name
        ? `${metaData?.first_name} ${metaData?.last_name}`
        : undefined) ||
      "",
    marital_status:
      filledForm?.documentDetails?.marital_status ||
      (metaData?.marital_status?.toLowerCase() === "single"
        ? "unmarried"
        : metaData?.marital_status?.toLowerCase() === "widower"
        ? "widow"
        : metaData?.marital_status?.toLowerCase() || ""),
    // name: filledForm?.documentDetails?.name || "",
    sex:
      filledForm?.documentDetails?.sex ||
      GENDER ||
      metaData?.gender?.toLowerCase() ||
      "",
    // place: filledForm?.documentDetails?.place || "",
    department_branch_section:
      filledForm?.documentDetails?.department_branch_section || "",
    permanent_address:
      filledForm?.documentDetails?.permanent_address ||
      (ADDRESS ? ADDRESS : undefined) ||
      metaData?.permanent_address ||
      "",
    // disrtict: filledForm?.documentDetails?.district || metaData?.Select_City || "",
    religion: filledForm?.documentDetails?.religion || "",
    // state: filledForm?.documentDetails?.state || metaData?.Select_State || ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [nomineeError, setNomineeError] = useState({});

  const validateNominee = () => {
    for (let i = 0; i < nominees.length; i++) {
      let nominee = nominees[i];
      if (nominee) {
        let keys = Object.keys(nominee);
        for (let j = 0; j < keys.length; j++) {
          let key = keys[j];
          if (nominee[key] === "") {
            return true;
          }
        }
      }
    }
    return false;
  };

  const addMore = (e) => {
    setNominees((prev) => {
      return [
        ...prev,
        {
          name_of_nominee: "",
          relationship: "",
          age_of_nominee: "",
          total_amount: "",
        },
      ];
    });
  };

  const deleteNominee = (_index) => {
    setNominees((prev) => {
      let arr = [...prev];
      // arr.splice(_index,1)
      arr[_index] = null;
      const total = arr
        ?.filter((nom) => nom !== null)
        ?.reduce((acc, nom) => {
          if (nom) return (acc = acc + Number(nom?.total_amount || 0));
        }, 0);
      setTotalAmt(total);
      return [...arr];
    });

    for (let key in nomineeError) {
      if (key.endsWith(_index)) {
        delete nomineeError[key];
      }
    }
  };

  const handleChange = (e) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeNominee = (e, _index) => {
    setIsFieldTouch(true);
    const { name, value } = e.target;
    setNominees((prev) => {
      let arr = [...prev];
      arr.forEach((item, index) => {
        if (index === _index) {
          item[name] = value;
        }
      });

      if (name === "total_amount") {
        const sum = arr
          ?.filter((nom) => nom !== null)
          ?.reduce((acc, nom) => {
            return (acc = acc + Number(nom?.total_amount));
          }, 0);
        setTotalAmt(sum);
      }

      if (name === "relationship") {
        if (hasNumeric(value) || hasSpecialCharacter(value)) {
          setNomineeError({
            ...nomineeError,
            [`relationship_${_index}`]: {
              message: "No numeric or special character allowed.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`relationship_${_index}`]: "",
          });
        }
      }

      if (name === "name_of_nominee") {
        if ((value && value.length < 3) || value.trim().length > 100) {
          setNomineeError({
            ...nomineeError,
            [`name_of_nominee_${_index}`]: {
              message: "This field must be more than 3 and less tha 100 char.",
              index: _index,
            },
          });
        } else {
          setNomineeError({
            ...nomineeError,
            [`name_of_nominee_${_index}`]: "",
          });
        }
      }

      return [...arr];
    });
  };

  const [totalAmt, setTotalAmt] = useState(0);
  console.log(totalAmt);
  useEffect(() => {
    let e = {};
    const total = nominees
      .filter((nom) => nom !== null)
      ?.reduce((acc, nom) => {
        if (nom) return (acc = acc + Number(nom?.total_amount || 0));
      }, 0);
    setTotalAmt(total);
  }, [nominees]);

  const isFormDataEmpty = () => {
    for (let key in formData) {
      if (formData[key].trim() === "") {
        return true;
      }
    }
    return false;
  };

  function getLastNonNullableIndex(array) {
    for (let i = array.length - 1; i >= 0; i--) {
      if (array[i] !== null && array[i] !== undefined) {
        return i;
      }
    }
    return -1;
  }

  const validateInput = (e) => {
    if (isFormDataEmpty()) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    setGratuityPreviewData({ ...formData, nominees });
    let e = {};

    // if (formData?.name.trim()) {
    //   e.name = isNameValid(formData.name);
    // }

    // if (formData?.name_of_employee.trim()) {
    //   e.name_of_employee = isNameValid(formData.name_of_employee);
    // }

    if (formData.religion && formData.religion?.trim().length < 3) {
      e.religion = "Religion must be greater than 3 char";
    } else {
      if (
        hasNumeric(formData.religion?.trim()) ||
        hasSpecialCharacter(formData.religion?.trim())
      ) {
        e.religion = "No numeric or special character allowed.";
      } else {
        e.religion = "";
      }
    }

    // if (formData.place && formData.place?.trim().length < 3) {
    //   e.place = "Place must be greater than 3 char";
    // } else {
    //   if (
    //     hasNumeric(formData.place?.trim()) ||
    //     hasSpecialCharacter(formData.place?.trim())
    //   ) {
    //     e.place = "No numeric or special character allowed.";
    //   } else {
    //     e.place = "";
    //   }
    // }

    // if (formData.district && formData.district?.trim().length < 3) {
    //   e.district = "District must be greater than 3 char";
    // } else {
    //   if (
    //     hasNumeric(formData.district?.trim()) ||
    //     hasSpecialCharacter(formData.district?.trim())
    //   ) {
    //     e.district = "No numeric or special character allowed.";
    //   } else {
    //     e.district = "";
    //   }
    // }

    // if (formData.state && formData.state?.trim().length < 3) {
    //   e.state = "State must be greater than 3 char";
    // } else {
    //   if (
    //     hasNumeric(formData.state?.trim()) ||
    //     hasSpecialCharacter(formData.state?.trim())
    //   ) {
    //     e.state = "No numeric or special character allowed.";
    //   } else {
    //     e.state = "";
    //   }
    // }

    // if (formData?.permanent_address.trim()) {
    //   e.permanent_address = isValidAddress(formData?.permanent_address);
    // }

    if ((totalAmt < 100 || totalAmt > 100) && totalAmt !== 0) {
      const errorIndex = getLastNonNullableIndex(nominees);
      setNomineeError({
        ...nomineeError,
        total_amount: {
          message: `total amout must be equal to ${100}`,
          index: errorIndex,
        },
      });
    } else {
      setNomineeError({
        ...nomineeError,
        total_amount: "",
      });
    }

    setError({ ...error, ...e });
  }, [formData, nominees, totalAmt]);

  const checkNomineeError = () => {
    for (let key in nomineeError) {
      if (nomineeError[key] !== "") {
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let flag = false;
    for (let key in error) {
      if (error[key] !== "") {
        flag = true;
        break;
      }
    }

    if (flag || checkNomineeError()) {
      swal({
        title: "Error",
        // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
        icon: "error",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
                  <p style="text-align:center">Before submit please resolve all the errors.</p>       
                `,
          },
        },
        buttons: {
          cancel: false,
          confirm: true,
        },
      }).then((flag) => {});
      return;
    }

    try {
      setLoading(true);
      await api.post(
        `/companyDocuments/DocumentMaping`,
        {
          companyDocumentId: form?._id,
          candidateId: id,
          documentDetails: {
            useNominee,
            ...formData,
            nominees: [...nominees.filter((nom) => nom !== null)],
          },
          formStatus: true,
        },
        { tokenType: "candidate" }
      );
      await getAllJoiningFilledForms();
      message.success("Your form has been submitted successfully!");
      setActivePanel(null);
      setLoading(false);
      setIsFieldTouch(false);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <Card>
      {loading ? (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      ) : (
        <div className="row">
          <div className="col-12">
            <p style={{ color: "red", fontSize: "14px" }}>
              <strong>Note:</strong> All fields marked with an asterisk (
              <span style={{ color: "red" }}>*</span>) are mandatory.
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              {/* <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name or Description of The Establishment
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  disabled={filledForm?.formStatusByHR}
                  name="name"
                  onChange={handleChange}
                  style={{
                    ...(error?.name ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.name}
                />
                {error?.name && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name}
                  </p>
                )}
              </div> */}
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Name of Employee
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="name_of_employee"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.name_of_employee
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.name_of_employee.replaceAll(
                    /\b[a-z]/g,
                    (p) => p.toUpperCase()
                  )}
                />
                {error?.name_of_employee && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.name_of_employee}
                  </p>
                )}
              </div>{" "}
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Permanent Address
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="permanent_address"
                  disabled={filledForm?.formStatusByHR || true}
                  onChange={handleChange}
                  style={{
                    ...(error?.permanent_address
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.permanent_address}
                />
                {error?.permanent_address && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.permanent_address}
                  </p>
                )}
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Religion
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="religion"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.religion ? { border: "1px solid red" } : {}),
                  }}
                  value={formData?.religion}
                />
                {error?.religion && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.religion}
                  </p>
                )}
              </div>
              {/* <div className="form-group col-md-2 form-builder-element mb-3">
                <label htmlFor="">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="place"
                  disabled={filledForm?.formStatusByHR}
                  name="place"
                  onChange={handleChange}
                  style={{
                    ...(error?.place ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.place}
                />
                {error?.place && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.place}
                  </p>
                )}
              </div> */}
              {/* <div className="form-group col-md-2 form-builder-element mb-3">
                <label htmlFor="">
                  District
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  disabled={filledForm?.formStatusByHR}
                  name="district"
                  onChange={handleChange}
                  style={{
                    ...(error?.district ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.district}
                />
                {error?.district && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.district}
                  </p>
                )}
              </div> */}
              {/* <div className="form-group col-md-2 form-builder-element mb-3">
                <label htmlFor="">
                  State
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  disabled={filledForm?.formStatusByHR}
                  name="state"
                  onChange={handleChange}
                  style={{
                    ...(error?.state ? { border: "1px solid red" } : {})
                  }}
                  value={formData?.state}
                />
                {error?.state && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.state}
                  </p>
                )}
              </div> */}
            </div>
            <div className="row">
              <div className="form-group mb-3 col-md-6 form-builder-element">
                <label htmlFor="">
                  Marital Status
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="grat_married"
                      name="marital_status"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="married"
                      checked={formData?.marital_status === "married"}
                    />
                    <label
                      htmlFor="grat_married"
                      className="custom-control-label"
                    >
                      Married
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="grat_unmarried"
                      name="marital_status"
                      type="checkbox"
                      disabled={filledForm?.formStatusByHR}
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      checked={formData?.marital_status === "unmarried"}
                      value="unmarried"
                    />
                    <label
                      htmlFor="grat_unmarried"
                      className="custom-control-label"
                    >
                      Unmarried
                    </label>
                  </div>
                  <div className="custom-control custom-radio mx-2">
                    <input
                      id="grat_widow"
                      name="marital_status"
                      type="checkbox"
                      disabled={filledForm?.formStatusByHR}
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      checked={formData?.marital_status === "widow"}
                      value="widow"
                    />
                    <label
                      htmlFor="grat_widow"
                      className="custom-control-label"
                    >
                      Widow
                    </label>
                  </div>
                    <div className="custom-control custom-radio mx-2">
                    <input
                      id="grat_separated"
                      name="marital_status"
                      disabled={filledForm?.formStatusByHR}
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="separated"
                      checked={formData?.marital_status === "separated"}
                    />
                    <label
                      htmlFor="grat_separated"
                      className="custom-control-label"
                    >
                      Separated
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group mb-3 col-md-4 form-builder-element">
                <label htmlFor="">
                  Sex
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className="custom-control custom-radio mx-3">
                    <input
                      id="grat_male"
                      disabled={filledForm?.formStatusByHR}
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="male"
                      checked={formData?.sex === "male"}
                    />
                    <label htmlFor="grat_male" className="custom-control-label">
                      Male
                    </label>
                  </div>

                  <div className="custom-control custom-radio mx-3">
                    <input
                      disabled={filledForm?.formStatusByHR}
                      id="grat_female"
                      name="sex"
                      type="checkbox"
                      className="custom-control-input form-view"
                      onChange={handleChange}
                      value="female"
                      checked={formData?.sex === "female"}
                    />
                    <label
                      htmlFor="grat_female"
                      className="custom-control-label"
                    >
                      Female
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group col-md-4 form-builder-element mb-3">
                <label htmlFor="">
                  Department/branch/section Where Employed
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className="form-control form-view"
                  type="text"
                  placeholder=""
                  name="department_branch_section"
                  disabled={filledForm?.formStatusByHR}
                  onChange={handleChange}
                  style={{
                    ...(error?.department_branch_section
                      ? { border: "1px solid red" }
                      : {}),
                  }}
                  value={formData?.department_branch_section}
                />
                {error?.department_branch_section && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    {error?.department_branch_section}
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              {nominees.map((nominee, index) => {
                if (nominee) {
                  row = row + 1;
                  return (
                    <Card
                      key={index}
                      title={
                        <div className="d-flex justify-content-between">
                          <span>{`Nominee ${row}`}</span>
                          <div>
                            {[...nominees.filter((nom) => nom !== null)]
                              .length !== 1 && (
                              <div className="col-1 ">
                                <button
                                  className={`btn ${"btn-danger"} ml-4`}
                                  onClick={() => deleteNominee(index)}
                                >
                                  <span className="pr-2">
                                    <i
                                      className="fa fa-trash"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      }
                    >
                      <div className="col-12">
                        <div className="row">
                          <div className="form-group col-md-4 form-builder-element mb-3">
                            <label htmlFor="">
                              Name in Full With Full Address of Nominee
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control form-view"
                              type="text"
                              placeholder=""
                              name="name_of_nominee"
                              disabled={filledForm?.formStatusByHR}
                              onChange={(e) => handleChangeNominee(e, index)}
                              style={{
                                ...(nomineeError[`name_of_nominee_${index}`]
                                  ?.index === index
                                  ? { border: "1px solid red" }
                                  : {}),
                              }}
                              value={nominee?.name_of_nominee.replaceAll(
                                /\b[a-z]/g,
                                (p) => p.toUpperCase()
                              )}
                            />
                            {nomineeError[`name_of_nominee_${index}`]?.index ===
                              index && (
                              <p style={{ color: "red", fontSize: "10px" }}>
                                {
                                  nomineeError[`name_of_nominee_${index}`]
                                    ?.message
                                }
                              </p>
                            )}
                          </div>
                          <div className="form-group col-md-4 form-builder-element mb-3">
                            <label htmlFor="">
                              Relationship With The Employee
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control form-view"
                              type="text"
                              placeholder=""
                              name="relationship"
                              disabled={filledForm?.formStatusByHR}
                              onChange={(e) => handleChangeNominee(e, index)}
                              style={{
                                ...(nomineeError[`relationship_${index}`]
                                  ?.index === index
                                  ? { border: "1px solid red" }
                                  : {}),
                              }}
                              value={nominee?.relationship}
                            />
                            {nomineeError[`relationship_${index}`]?.index ===
                              index && (
                              <p style={{ color: "red", fontSize: "10px" }}>
                                {nomineeError[`relationship_${index}`]?.message}
                              </p>
                            )}
                          </div>
                          <div className="form-group col-md-4 form-builder-element mb-3">
                            <label htmlFor="">
                              Age of The Nominee
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control form-view"
                              type="number"
                              placeholder=""
                              name="age_of_nominee"
                              disabled={filledForm?.formStatusByHR}
                              onChange={(e) => handleChangeNominee(e, index)}
                              style={{
                                ...(error?.age_of_nominee
                                  ? { border: "1px solid red" }
                                  : {}),
                              }}
                              value={nominee?.age_of_nominee}
                            />
                          </div>
                          <div className="form-group col-md-4 form-builder-element mb-3">
                            <label htmlFor="">
                              Propotion by Which Gratuity Will Shared
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control form-view"
                              type="number"
                              disabled={filledForm?.formStatusByHR}
                              name="total_amount"
                              max={formatDate(new Date())}
                              onChange={(e) => handleChangeNominee(e, index)}
                              style={{
                                ...(nomineeError?.total_amount?.index === index
                                  ? { border: "1px solid red" }
                                  : {}),
                              }}
                              value={nominee?.total_amount}
                            />
                            {nomineeError?.total_amount &&
                              nomineeError?.total_amount?.index === index && (
                                <p style={{ color: "red", fontSize: "10px" }}>
                                  {nomineeError?.total_amount?.message}
                                </p>
                              )}
                          </div>
                          {[...nominees.filter((nom) => nom !== null)].length <
                            5 &&
                            row ===
                              [...nominees.filter((nom) => nom !== null)]
                                .length && (
                              <div className="form-group col-md-3 mb-0 form-builder-element  d-flex justify-content-end  align-items-end">
                                <button
                                  className={`btn ${
                                    totalAmt >= 100
                                      ? "btn-secondary"
                                      : "btn-primary"
                                  }  ${"mt-2 mt-sm-0"} `}
                                  onClick={addMore}
                                  disabled={totalAmt >= 100}
                                >
                                  <span className="pr-2">
                                    <i
                                      className="fa fa-plus"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  Add More
                                </button>
                              </div>
                            )}
                        </div>
                      </div>
                    </Card>
                  );
                }
              })}
            </div>
            {!nomineeEPF?.documentDetails?.useNominee &&
            !nomineeWages?.documentDetails?.useNominee ? (
              <div className="row">
                <div className="col-12 d-flex align-items-center gap-1 mt-4">
                  <input
                    type="checkbox"
                    id="gratuity_nominee"
                    checked={useNominee}
                    disabled={filledForm?.isFilledStatus}
                    onChange={(e) => {
                      setUseNominee(e.target.checked);
                    }}
                  />
                  <label htmlFor="gratuity_nominee" className="mb-0">
                    Check this box to apply nominee details to every form
                    automatically.
                  </label>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className="row">
              <div className="col-12 d-flex justify-content-center mt-4">
                <button
                  className={`btn ${
                    validateInput() ||
                    validateNominee() ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE
                      ? "btn-secondary"
                      : "btn-primary"
                  } `}
                  onClick={handleSubmit}
                  disabled={
                    validateInput() ||
                    validateNominee() ||
                    filledForm?.formStatusByHR ||
                    IS_DISABLE
                  }
                >
                  <span className="pr-2">
                    <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </span>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  );
}

export default Gratuity;
